import { useTranslate } from 'ra-core'

const AdCampaignTitle = ({ record }: { record?: { name?: string } }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Ad Campaign')} - {record && record.name ? `"${record.name}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./AdCampaignList') },
  edit: { lazy: () => import('./AdCampaignEdit') },
  create: { lazy: () => import('./AdCampaignCreate') },
  options: {
    create: {
      title: 'Create Ad Campaign',
      subtitle: null,
      breadCrumb: 'Create Ad Campaign',
    },
    list: {
      title: 'Ad Campaigns',
      subtitle: null,
      breadCrumb: 'Ad Campaigns',
    },
    edit: {
      title: <AdCampaignTitle />,
      subtitle: null,
      breadCrumb: 'Edit Ad Campaign',
    },
  },
}
